/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-21 11:06:36
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-09-23 11:03:37
 */
import store from '@/store';
export default {
	inserted(el, binding, vnode) {
		const value = binding.value;
		// 校验权限
		const all_permission = '*:*:*';
		const permissions = store.getters && store.getters.accountPermissions;

		if (value && value instanceof Array && value.length > 0) {
			const permissionFlag = value;

			const hasPermissions = permissions.some(permission => {
				return all_permission === permission || permissionFlag.includes(permission);
			});
			if (value === 'tags:list') console.log(hasPermissions);
			if (!hasPermissions) {
				// el.parentNode && el.parentNode.removeChild(el);
				el.style.display = 'none';
			} else {
				el.style.display = '';
			}
		}
	},
	update(el, binding, vnode) {
		const value = binding.value;
		// 校验权限
		const all_permission = '*:*:*';
		const permissions = store.getters && store.getters.accountPermissions;

		if (value && value instanceof Array && value.length > 0) {
			const permissionFlag = value;

			const hasPermissions = permissions.some(permission => {
				return all_permission === permission || permissionFlag.includes(permission);
			});
			if (!hasPermissions) {
				// el.parentNode && el.parentNode.removeChild(el);
				el.style.display = 'none';
			} else {
				el.style.display = '';
			}
		}
	},
};
